import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Navigation, MapPin } from "lucide-react";
import { openInNativeMapApp } from "@/lib/addressFormat";

interface NavigationChoiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  address: string;
  label?: string;
}

export function NavigationChoiceDialog({ open, onOpenChange, address, label }: NavigationChoiceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs mx-auto">
        <DialogHeader>
          <DialogTitle className="text-center text-base">
            {label || "Navigate to Address"}
          </DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground text-center mb-2 px-2 break-words">{address}</p>
        <div className="flex flex-col gap-2">
          <Button
            variant="outline"
            className="w-full justify-start gap-3 h-12 border-primary/30 hover:bg-primary/5"
            onClick={() => {
              openInNativeMapApp(address, "apple");
              onOpenChange(false);
            }}
          >
            <MapPin className="w-5 h-5 text-primary" />
            <span className="font-medium">Apple Maps</span>
          </Button>
          <Button
            variant="outline"
            className="w-full justify-start gap-3 h-12 border-primary/30 hover:bg-primary/5"
            onClick={() => {
              openInNativeMapApp(address, "google");
              onOpenChange(false);
            }}
          >
            <Navigation className="w-5 h-5 text-green-600" />
            <span className="font-medium">Google Maps</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
